// import React, { Component } from "react";
// import { connect } from "react-redux";
// // import { withRouter } from 'react-router-dom';

// import NavLogo from "./NavLogo";
// import NavContent from "./NavContent";
// import OutsideClick from "./OutsideClick";
// import Aux from "./../../../../hoc/_Aux";
// import * as actionTypes from "./../../../../store/actions";
// import navigation from "../../../../menu-items";
// import config from "../../../../config";

// class Navigation extends Component {
//   // resize = () => {
//   //   const contentWidth = document.getElementById("root").clientWidth; // #root의 width값

//   //   // width값이 992미만이고 config의 layout이 horizontal 경우 vertical로 바꿔줌
//   //   if (this.props.layout === "horizontal" && contentWidth < 992) {
//   //     this.props.onChangeLayout("vertical");
//   //   }
//   // };

//   // componentDidMount() {
//   //   this.resize();
//   //   window.addEventListener("resize", this.resize);
//   // }

//   // componentWillUnmount() {
//   //   window.removeEventListener("resize", this.resize);
//   // }

//   render() {
//     let navClass = ["pcoded-navbar"];

//     // // config의 preLayoutd이 null로 할당되어있고, 조건식은 null,"",layout-6, layout-8 이 아니라면 let navClass = ["pcoded-navbar , preLayout 값"]
//     // if (
//     //   this.props.preLayout !== null &&
//     //   this.props.preLayout !== "" &&
//     //   this.props.preLayout !== "layout-6" &&
//     //   this.props.preLayout !== "layout-8"
//     // ) {
//     //   navClass = [...navClass, this.props.preLayout];
//     //   // 그게 아니라면 let navClass = ["pcoded-navbar , menu-light, navbar-default, brand-default ,drp-icon-style1, menu-item-icon, style1, active-default, title-default"]
//     // } else {
//     //   navClass = [
//     //     ...navClass,
//     //     this.props.layoutType,
//     //     this.props.navBackColor,
//     //     this.props.navBrandColor,
//     //     "drp-icon-" + this.props.navDropdownIcon,
//     //     "menu-item-icon-" + this.props.navListIcon,
//     //     this.props.navActiveListColor,
//     //     this.props.navListTitleColor,
//     //   ];
//     //   //layout = "vertical"
//     //   //config의 layout이 horizontal 이면 navClass에 theme-horizontal 추가
//     //   if (this.props.layout === "horizontal") {
//     //     navClass = [...navClass, "theme-horizontal"];
//     //   }
//     //   //navBackImage = false
//     //   //config의 navBackImage있다면 navClass에 navBackImage 값 추가
//     //   if (this.props.navBackImage) {
//     //     navClass = [...navClass, this.props.navBackImage];
//     //   }
//     //   //navIconColor = false
//     //   //config의 navIconColor있다면 navClass에 icon-colored 추가
//     //   if (this.props.navIconColor) {
//     //     navClass = [...navClass, "icon-colored"];
//     //   }
//     //   //navFixedLayout =true
//     //   //config의 navFixedLayout있다면 navClass에 menupos-static 추가
//     //   if (!this.props.navFixedLayout) {
//     //     navClass = [...navClass, "menupos-static"];
//     //   }
//     //   //navListTitleHide = false
//     //   //config의 navListTitleHide있다면 navClass에 caption-hide 추가
//     //   if (this.props.navListTitleHide) {
//     //     navClass = [...navClass, "caption-hide"];
//     //   }
//     // }
//     // // 가로 화면이 992보다 작고 collapseMenu있다면 navClass에 mob-open 추가
//     // // 미니화면일 때 가로화면을 992보다 작게했을 때 메뉴가 보임
//     // if (this.props.windowWidth < 992 && this.props.collapseMenu) {
//     //   navClass = [...navClass, "mob-open"];
//     //   //그게 아니라면  navClass에 navbar-collapsed 추가
//     //   // 미니화면이 모바일(992px보다 작을 때)에서 보임
//     // } else if (this.props.collapseMenu) {
//     //   navClass = [...navClass, "navbar-collapsed"];
//     // }

//     // //preLayout이 "layout-6" 라면 body태그에 layout-6 클래스 추가 , body의 배경이미지는 layout6Background값으로, 배경 이미지 사이즈는 layout6BackSize 값으로
//     // if (this.props.preLayout === "layout-6") {
//     //   document.body.classList.add("layout-6");
//     //   document.body.style.backgroundImage = this.props.layout6Background;
//     //   document.body.style.backgroundSize = this.props.layout6BackSize;
//     // }
//     // //preLayout이 "layout-8" 라면 body태그에 layout-8 클래스 추가
//     // if (this.props.preLayout === "layout-8") {
//     //   document.body.classList.add("layout-8");
//     // }
//     // //layoutType이 "dark"라면 body태그에 datta-dark 클래스 추가
//     // if (this.props.layoutType === "dark") {
//     //   document.body.classList.add("datta-dark");
//     //   //그게아니라면 body태그에 datta-dark 클래스 삭제
//     // } else {
//     //   document.body.classList.remove("datta-dark");
//     // }
//     // //rtlLayout 있다면 body태그에 datta-rtl 클래스 추가
//     // if (this.props.rtlLayout) {
//     //   document.body.classList.add("datta-rtl");
//     //   //그게아니라면 body태그에 datta-rtl 클래스 삭제
//     // } else {
//     //   document.body.classList.remove("datta-rtl");
//     // }
//     // //boxLayout 있다면 body태그에 container, box-layout 클래스 추가
//     // if (this.props.boxLayout) {
//     //   document.body.classList.add("container");
//     //   document.body.classList.add("box-layout");
//     //   //그게 아니라면 body태그에 container, box-layout 클래스 삭제
//     // } else {
//     //   document.body.classList.remove("container");
//     //   document.body.classList.remove("box-layout");
//     // }

//     let navContent = (
//       <div className="navbar-wrapper">
//         {/* navbar-brand header-logo 부분 */}
//         {/* <NavLogo
//           collapseMenu={this.props.collapseMenu}
//           windowWidth={this.props.windowWidth}
//           onToggleNavigation={this.props.onToggleNavigation}
//         /> */}
//         {/* menu-items.js의 items */}
//         <NavContent navigation={navigation.items} />
//       </div>
//     );

//     // // 가로사이즈가 992보다 작을 경우
//     // if (this.props.windowWidth < 992) {
//     //   navContent = (
//     //     // <OutsideClick> 컴포넌트 바깥을 클릭했을 때에 대한 이벤트
//     //     //<OutsideClick>이 감싸고 있는 .navbar-wrapper 바깥 쪽을 클릭하게 되면 실행되는 이벤트
//     //     <OutsideClick>
//     //       <div className="navbar-wrapper">
//     //         <NavLogo
//     //           collapseMenu={this.props.collapseMenu}
//     //           windowWidth={this.props.windowWidth}
//     //           onToggleNavigation={this.props.onToggleNavigation}
//     //         />
//     //         <NavContent navigation={navigation.items} />
//     //       </div>
//     //     </OutsideClick>
//     //   );
//     // }

//     return (
//       <Aux>
//         <nav className={navClass.join(" ")}>{navContent}</nav>
//       </Aux>
//     );
//   }
// }

// const mapStateToProps = (state) => {
//   return {
//     layout: state.layout,
//     preLayout: state.preLayout,
//     collapseMenu: state.collapseMenu,
//     layoutType: state.layoutType,
//     navBackColor: state.navBackColor,
//     navBackImage: state.navBackImage,
//     navIconColor: state.navIconColor,
//     navBrandColor: state.navBrandColor,
//     layout6Background: state.layout6Background,
//     layout6BackSize: state.layout6BackSize,
//     rtlLayout: state.rtlLayout,
//     navFixedLayout: state.navFixedLayout,
//     boxLayout: state.boxLayout,
//     navDropdownIcon: state.navDropdownIcon,
//     navListIcon: state.navListIcon,
//     navActiveListColor: state.navActiveListColor,
//     navListTitleColor: state.navListTitleColor,
//     navListTitleHide: state.navListTitleHide,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
//     onChangeLayout: (layout) =>
//       dispatch({ type: actionTypes.CHANGE_LAYOUT, layout: layout }),
//   };
// };

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(windowSize(Navigation));

import React, { Component } from "react";
import { connect } from "react-redux";
// import { withRouter } from 'react-router-dom';

import NavLogo from "./NavLogo";
import NavContent from "./NavContent";
import OutsideClick from "./OutsideClick";
import Aux from "./../../../../hoc/_Aux";
import * as actionTypes from "./../../../../store/actions";
import navigation from "../../../../menu-items";
import config from "../../../../config";

import * as fnc from "../../../../commonFunc/CommonFunction";
import axios from "axios";

class Navigation extends Component {
  render() {
    const { menuItems } = this.props;

    let navClass = ["pcoded-navbar"];

    let navContent = (
      <div className="navbar-wrapper">
        {/* navbar-brand header-logo 부분 */}
        {/* menu-items.js의 items */}
        {/* <NavContent
          navigation={
            menuItems.length !== 0 ? menuItems.items : navigation.items
          }
        /> */}

        <NavContent
          navigation={!menuItems.items ? navigation.items : menuItems.items}
        />
      </div>
    );

    return (
      <Aux>
        <nav className={navClass.join(" ")}>{navContent}</nav>
      </Aux>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuItems: state.menuItems,
    layout: state.layout,
    preLayout: state.preLayout,
    collapseMenu: state.collapseMenu,
    layoutType: state.layoutType,
    navBackColor: state.navBackColor,
    navBackImage: state.navBackImage,
    navIconColor: state.navIconColor,
    navBrandColor: state.navBrandColor,
    layout6Background: state.layout6Background,
    layout6BackSize: state.layout6BackSize,
    rtlLayout: state.rtlLayout,
    navFixedLayout: state.navFixedLayout,
    boxLayout: state.boxLayout,
    navDropdownIcon: state.navDropdownIcon,
    navListIcon: state.navListIcon,
    navActiveListColor: state.navActiveListColor,
    navListTitleColor: state.navListTitleColor,
    navListTitleHide: state.navListTitleHide,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
    onChangeLayout: (layout) =>
      dispatch({ type: actionTypes.CHANGE_LAYOUT, layout: layout }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);
